module.exports = __webpack_public_path__ + "static/media/sc26.34.35.8579b59f.mp4";